import { useModal } from "@/common/contexts/Modal.context";
import { AccountType } from "@/common/types";
import { Button, Select } from "antd";
import Form, { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router";
import FormItem from "antd/es/form/FormItem";
import Typography from "../Typography/Typography";

const { Option } = Select;
const user_variants = [
  { value: "customer", label: "Customer" },
  { label: "Vendor", value: "vendor" },
];
export default function CreateNewCompanyModal() {
  const [form] = useForm();
  const navigate = useNavigate();
  const { closeModal } = useModal();
  const redirectOnCreatePage = (acc_type: AccountType) => {
    closeModal();
    navigate(`/company/register?companyType=${acc_type}`);
  };
  const onSubmit = (values: { acc_type: AccountType }) => {
    redirectOnCreatePage(values.acc_type);
  };
  return (
    <>
      <Form
        form={form}
        onFinish={onSubmit}
        name="modal-create-new-company"
        className="px-6"
      >
        <Typography
          mb={6}
          px={20}
          type="p"
          textColor="black"
          fontSize={24}
          fontWeight="font-semibold"
          fontFamily="font-kanit"
          className="text-center"
        >
          Create New Company
        </Typography>
        <div className="flex flex-col gap-9 items-center justify-center pt-4 w-[376px]">
          <FormItem
            name="acc_type"
            initialValue="customer"
            className="w-full mb-0"
          >
            <Select
              style={{ height: 50 }}
              size="large"
              className="font-kanit text-[15px] leading-[22px] font-light text-blackTransparent w-full shadow-sm bg-primaryDim rounded-lg border-2 border-primaryDim"
            >
              {user_variants.map((el) => (
                <Option
                  className="font-kanit text-[15px] leading-[22px] font-light text-blackTransparent "
                  value={el.value}
                  key={el.value}
                >
                  {el.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <div>
            <Button
              htmlType="submit"
              className="mx-auto h-10 w-full max-w-[253px] font-inter font-semibold text-base text-white px-8"
              type="primary"
            >
              <Typography py={18} type="p" customStyles="block">
                Continue
              </Typography>
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
}
